import { render, staticRenderFns } from "./TextBodySmall.vue?vue&type=template&id=02c56573&scoped=true"
import script from "./TextBodySmall.vue?vue&type=script&lang=js"
export * from "./TextBodySmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c56573",
  null
  
)

export default component.exports